<template>
  <symbol
    id="angle-left"
    viewBox="0 0 192 322"
  >
    <path
      d="M4.20005 152.5L151 4.49998C155.7 -0.200024 163.3 -0.200024 168 4.49998L187.8 24.3C192.5 29 192.5 36.6 187.8 41.3L69.3 161L187.8 280.7C192.5 285.4 192.5 293 187.8 297.7L168 317.5C163.3 322.2 155.7 322.2 151 317.5L4.20005 169.5C-0.499951 164.8 -0.499951 157.2 4.20005 152.5Z"
    />
  </symbol>
</template>
